<template>
  <div
    v-if="visible"
    class="cw-at-mention-panel"
    :style="panelStyle"
    @mousedown.prevent
  >
    <div class="cw-at-mention-panel__head">
      <span class="text-[12px] font-bold text-gray-200">引用素材</span>
      <span v-if="query" class="text-[11px] text-gray-500">@{{ query }}</span>
    </div>
    <div class="cw-at-mention-panel__body">
      <div v-if="loading" class="py-6 text-center text-[12px] text-gray-500">加载中…</div>
      <div v-else-if="!items.length" class="py-6 px-3 text-center text-[12px] text-gray-500 leading-relaxed">
        暂无可用素材。请先上传或使用「+」添加，也可在资产库中选择。
      </div>
      <button
        v-for="(item, idx) in items"
        :key="item.url + '-' + idx"
        type="button"
        class="cw-at-mention-panel__item"
        :class="{ 'cw-at-mention-panel__item--active': idx === activeIndex }"
        @click="$emit('pick', item)"
        @mouseenter="$emit('hover-index', idx)"
      >
        <span class="cw-at-mention-panel__thumb">
          <img
            v-if="item.kind === 'image'"
            :src="item.url"
            alt=""
            loading="lazy"
            class="h-full w-full object-cover"
          />
          <span v-else class="relative block h-full w-full">
            <video :src="item.url" muted playsinline preload="metadata" class="h-full w-full object-cover"></video>
            <i class="fas fa-play-circle absolute inset-0 m-auto h-4 w-4 text-white/80"></i>
          </span>
        </span>
        <span class="min-w-0 flex-1 text-left">
          <span class="block truncate text-[13px] font-semibold text-gray-100">{{ item.name }}</span>
          <span class="block truncate text-[10px] text-gray-500">{{
            item.source === 'asset' ? '我的资产' : '本次上传'
          }}</span>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComposerAtMentionPanel',
  props: {
    visible: { type: Boolean, default: false },
    items: { type: Array, default: () => [] },
    activeIndex: { type: Number, default: 0 },
    query: { type: String, default: '' },
    panelStyle: { type: Object, default: () => ({}) },
    loading: { type: Boolean, default: false }
  }
}
</script>

<style scoped>
.cw-at-mention-panel {
  pointer-events: auto;
  overflow: hidden;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(22, 22, 28, 0.98);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.55);
}

.cw-at-mention-panel__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.cw-at-mention-panel__body {
  max-height: 260px;
  overflow-y: auto;
  padding: 6px;
}

.cw-at-mention-panel__item {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 12px;
  border: 1px solid transparent;
  background: transparent;
  transition: background 0.12s ease, border-color 0.12s ease;
}

.cw-at-mention-panel__item:hover,
.cw-at-mention-panel__item--active {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.1);
}

.cw-at-mention-panel__thumb {
  display: block;
  height: 40px;
  width: 40px;
  flex-shrink: 0;
  overflow: hidden;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(0, 0, 0, 0.35);
}
</style>
